
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/otel-course",
      function () {
        return require("private-next-pages/otel-course.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/otel-course"])
      });
    }
  